import {
  Button,
  DropdownButton,
  FlexBox,
  Image,
  Text,
} from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { NotificationHistoryType } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { createRef, PureComponent, RefObject } from 'react';
import { Link } from 'react-router-dom';


import { TopbarButton } from '../topbarButton';

import NoNotifications from './no-notifications.png';
import { NotificationHistoryItem } from './notificationHistoryItem';
import styles from './notificationTopbarButton.module.scss';

type PropsT = {
  notificationsHistory: ReadonlyArray<NotificationHistoryType>;
  notificationHistoryReset: () => void;
  className?: string;
  alignCenter?: boolean;
};

export class NotificationTopbarButton extends PureComponent<PropsT> {
  triggerRef: RefObject<any>;

  constructor(props: PropsT) {
    super(props);

    this.triggerRef = createRef();
  }

  onToggleDropdown(isOpen: boolean) {
    if (isOpen) {
      ampli.topbarNotificationsOpened();
    }
  }

  @boundMethod
  notificationHistoryReset() {
    this.props.notificationHistoryReset();
  }

  @boundMethod
  close() {
    if (this.triggerRef.current) {
      this.triggerRef.current.click();
    }
  }

  render() {
    const { className, notificationsHistory } = this.props;

    let showHistoryNotificationDevider = true;
    let dropdownNotificationsFirstFive;
    let dropdownNotificationsAll;
    let showUnread = false;
    let clearNotifications;
    let restOftotalNotificationNumber = 0;
    let notifications = (
      <FlexBox className={styles.empty} flexDirection="column">
        <Image src={NoNotifications} alt="no-notifications" />
        <h3>Awesome</h3>
        <h4>No notifications</h4>
      </FlexBox>
    );

    if (notificationsHistory.length > 0) {
      showHistoryNotificationDevider = true;
      let counter = 0;

      dropdownNotificationsFirstFive = notificationsHistory
        .filter((n: NotificationHistoryType) => {
          if (n.showInDropdown === true && counter < 3) {
            counter++;
            return n;
          }
          return false;
        })
        .reverse();

      dropdownNotificationsAll = notificationsHistory.filter(
        (n: NotificationHistoryType) => {
          if (n.showInDropdown === true) {
            counter++;
            return n;
          }
          return false;
        },
      );

      if (
        dropdownNotificationsAll.length > dropdownNotificationsFirstFive.length
      ) {
        restOftotalNotificationNumber = notificationsHistory.length - 3;
      }

      if (
        !dropdownNotificationsFirstFive ||
        dropdownNotificationsFirstFive.length === 0
      ) {
        notifications = (
          <FlexBox className={styles.empty} flexDirection="column">
            <Image src={NoNotifications} alt="no-notifications" />
            <h3>Awesome</h3>
            <h4>No missed notifications</h4>
          </FlexBox>
        );
      } else {
        showHistoryNotificationDevider = false;
        notifications = dropdownNotificationsFirstFive.map(
          (n: NotificationHistoryType) => {
            return <NotificationHistoryItem key={n.id} notification={n} />;
          },
        );
        clearNotifications = (
          <FlexBox>
            <Button
              variant="tertiary"
              className={styles.clearNotificationsHistoryButton}
              onClick={this.notificationHistoryReset}
            >
              Mark all as seen
            </Button>
          </FlexBox>
        );
      }
    }

    const unseenNotifications = notificationsHistory.filter(
      (n: NotificationHistoryType) => n.unseen === true,
    );

    if (unseenNotifications.length > 0) {
      showUnread = true;
    }

    const DropdownContent = (
      <FlexBox
        className={classnames(
          { [styles.fullWidthContent]: this.props.alignCenter },
          styles.content,
        )}
        flexDirection="column"
        id="topbar-notification-dropdown"
      >
        <FlexBox
          role="headline"
          className={styles.headline}
          flexDirection="row"
          flexWrap="wrap"
        >
          <Text.Heading>Notifications</Text.Heading>
          {clearNotifications}
          <span className={styles.badge}>{unseenNotifications.length}</span>
        </FlexBox>
        <FlexBox
          flexDirection="row"
          role="separator"
          className={styles.divider}
        ></FlexBox>
        {notifications}
        {showHistoryNotificationDevider && (
          <FlexBox
            flexDirection="row"
            role="separator"
            className={styles.divider}
          ></FlexBox>
        )}
        <FlexBox role="more" className={styles.more} flexDirection="column">
          <Link to="/notifications" onClick={this.close} id="">
            See all notifications{' '}
            {restOftotalNotificationNumber > 0
              ? `(${restOftotalNotificationNumber} more)`
              : notificationsHistory.length > 0
              ? `(${notificationsHistory.length})`
              : ''}
          </Link>
        </FlexBox>
      </FlexBox>
    );

    const rootClass = classnames(
      {
        [styles.root]: styles.root,
      },
      className,
    );

    return (
      <DropdownButton
        icon="bell"
        className={rootClass}
        onToggle={this.onToggleDropdown}
        noArrow
        noStyle
        dropdown={DropdownContent}
        dropdownProps={{
          className: classnames({
            [styles.dropdownMenuAlignCenter]: this.props.alignCenter,
          }),
        }}
      >
        <TopbarButton
          showNotificationIndicator={showUnread}
          icon="bell"
          id="topbar-notification-button"
          tooltip="Notifications"
        />
      </DropdownButton>
    );
  }
}
